import { httpCall } from "../../../Services/HttpService"
import { API_URL } from "../../../Utils/Urls"
export const getReports = () => {
  return httpCall({
    url: API_URL.GET_OPINIONS,
    method: "post"
  }).then(response => {
    return response
  });
};


export const getReportById = (params) => {
  return httpCall({
    url: API_URL.GET_OPINION_BY_ID,
    method: "post",
    data : params
  }).then(response => {
    return response
  });
};

